import React from 'react';
import {Stack, Typography} from "@mui/material"
import {Outlet} from "react-router-dom"
import {useApi} from "../../hooks/useApi"
import {SystemRole} from "../../api/enum/SystemRole"
import OrgSidebar from "./Nav/OrgSidebar"
import RightSidebar from "./RightSidebar"
import ContentArea from "./ContentArea"
import ActivitiesList from "../activities/ActivitiesList"
import BreadcrumbsLayer from "./Nav/BreadcrumbsLayer"
import {NAV_LABELS} from "../../library/NavLabels"

function AdminContainer() {
    const { currentUser } = useApi()

    return (
        <BreadcrumbsLayer items={[{label: NAV_LABELS.ADMIN, url: "/admin"}]}>
            <OrgSidebar/>
            <ContentArea>
                {currentUser?.systemRole === SystemRole.ADMIN
                    ? <Outlet/>
                    : <>Nothing to see here.</>
                }
            </ContentArea>
            <RightSidebar>
                <Stack spacing={3}>
                    <Typography variant="subtitle1">Latest Activity</Typography>
                    <ActivitiesList/>
                </Stack>
            </RightSidebar>
        </BreadcrumbsLayer>
    )
}

export default AdminContainer;
